import { CustomFieldDefinition, CustomFieldsMapper } from '@nx-smartmonkey/shared/domain';
import { Task } from '../../domain/task/Task';
import { TaskDTO } from '../../domain/task/TaskDTO';
import { TaskRepositoryDTO } from '../../domain/task/TaskRepositoryDTO';

export class TaskMapper {
  static toDomain(props: TaskDTO, customFieldDefinitions: CustomFieldDefinition[]): Task {
    const {
      id,
      stop_id,
      label,
      comments,
      barcode,
      status,
      custom_fields,
      created_by,
      created_at,
      updated_at,
      deleted_at,
    } = props;

    return Task.create(
      {
        stop_id,
        label,
        comments,
        barcode,
        status,
        custom_fields: custom_fields ? CustomFieldsMapper.toDomain(custom_fields, customFieldDefinitions) : undefined,
        created_by,
        created_at,
        updated_at,
        deleted_at,
      },
      id
    );
  }

  static toDTO(task: Task): TaskDTO {
    return {
      id: task.id,
      stop_id: task.stop_id,
      label: task.label,
      comments: task.comments,
      barcode: task.barcode,
      status: task.status,
      custom_fields: task.custom_fields?.value,
      created_by: task.created_by,
      created_at: task.created_at,
      updated_at: task.updated_at,
      deleted_at: task.deleted_at,
    };
  }

  static toRepository(task: Task): TaskRepositoryDTO {
    return {
      label: task.label,
      barcode: task.barcode,
      comments: task.comments,
      status: task.status,
      custom_fields: task.custom_fields ? CustomFieldsMapper.toRepository(task.custom_fields) : undefined,
    };
  }
}
